import { j as e } from "./atoms-v218.js";
import { useFloating as E, useClick as S, useRole as V, useDismiss as q, useInteractions as G, FloatingPortal as J, FloatingFocusManager as K } from "./atoms-v280.js";
import { createContext as Q, forwardRef as h, useId as v, useMemo as g, useContext as U } from "react";
import { useTheme as X } from "styled-components";
import { useBreakpoints as M } from "./atoms-v251.js";
import { Button as f } from "./atoms-v26.js";
import { Text as Y } from "./atoms-v243.js";
import { Icon as j } from "./atoms-v217.js";
import { overlayAnimations as Z, standardDialogAnimations as H, drawerDialogAnimations as _ } from "./atoms-v2708.js";
import { Overlay as ee, Dialog as oe, HeaderWithTabs as re, HeaderContainerWithTabs as te, LeftPadding as ae, HeaderTabsSpacer as se, HeaderRightWithTabs as ne, Header as ie, HeaderLeft as le, HeaderCenter as de, HeaderTitle as ce, HeaderRight as me, Content as ue, Footer as xe } from "./atoms-v2707.js";
import { Tabs as he } from "./atoms-v240.js";
import { motion as F } from "./atoms-v2709.js";
import { AnimatePresence as pe } from "./atoms-v2710.js";
function ge(r, t, o) {
  return () => {
    if (o === "standard")
      return H(r);
    switch (t) {
      case "medium":
        return H(r);
      case "small":
      default:
        return _(r);
    }
  };
}
const k = Q(null), R = h(
  ({
    className: r,
    colorTheme: t = "light",
    disabledOverlay: o = !1,
    id: l,
    initialFocusIdx: a = 0,
    isAlert: d,
    isOpen: i,
    renderChildren: c,
    root: m,
    setIsOpen: n,
    variant: s = "standard"
  }, u) => {
    const p = X(), { current: y } = M(), $ = v(), C = v(), O = g(() => F(ee), []), w = g(() => F(oe), []), z = g(ge(p, y, s), [
      y,
      p,
      s
    ]), { context: x, refs: I } = E({
      onOpenChange: n,
      open: i
    }), L = S(x, {
      enabled: !0,
      event: "click",
      ignoreMouse: !1,
      keyboardHandlers: !1,
      toggle: !1
    }), N = V(x, { role: d ? "alertdialog" : "dialog" }), T = q(x, { outsidePressEvent: "mousedown" }), { getFloatingProps: W } = G([L, T, N]), B = U(k), b = m || B;
    return /* @__PURE__ */ e.jsx(pe, { children: i && /* @__PURE__ */ e.jsx(J, { ...b && { id: b }, children: /* @__PURE__ */ e.jsx(
      O,
      {
        lockScroll: !0,
        $disabledOverlay: o,
        $variant: s,
        animate: "visible",
        className: "modal-overlay",
        exit: "hidden",
        id: l,
        initial: "hidden",
        ref: u,
        style: { position: m ? "absolute" : "fixed" },
        variants: Z(p),
        children: /* @__PURE__ */ e.jsx(K, { context: x, initialFocus: a, children: /* @__PURE__ */ e.jsx(
          w,
          {
            $colorTheme: t,
            $variant: s,
            "aria-describedby": C,
            "aria-labelledby": $,
            ref: I.setFloating,
            variants: z,
            ...W(),
            className: r,
            children: c({ descriptionId: C, headerId: $, variant: s })
          }
        ) })
      },
      l
    ) }) });
  }
);
R.displayName = "ModalWrapper";
const P = h(
  ({
    alignment: r = "center",
    className: t,
    colorTheme: o = "light",
    headingId: l,
    navigationTabs: a,
    onClickBack: d,
    onClickClose: i,
    subheading: c,
    title: m = "",
    variant: n
  }, s) => {
    const { current: u } = M();
    return /* @__PURE__ */ e.jsx(e.Fragment, { children: a ? /* @__PURE__ */ e.jsx(re, { $colorTheme: o, $variant: n, children: /* @__PURE__ */ e.jsxs(te, { children: [
      /* @__PURE__ */ e.jsx(ae, { $colorTheme: o }),
      /* @__PURE__ */ e.jsx(
        he,
        {
          colorTheme: o,
          onChange: a.onChange,
          selectedValue: a.selectedValue,
          size: a.size || "modal",
          tabs: a.tabs
        }
      ),
      /* @__PURE__ */ e.jsx(se, { $colorTheme: o }),
      /* @__PURE__ */ e.jsx(ne, { $colorTheme: o, children: /* @__PURE__ */ e.jsx(f, { iconOnly: !0, ariaLabel: "Close modal", onClick: i, variant: "ghost", children: /* @__PURE__ */ e.jsx(j, { name: "close--large", size: u === "small" ? "small" : "large" }) }) })
    ] }) }) : /* @__PURE__ */ e.jsxs(
      ie,
      {
        $colorTheme: o,
        $variant: n,
        className: t,
        id: l,
        ref: s,
        children: [
          r === "center" && /* @__PURE__ */ e.jsx(le, { $variant: n, children: d && /* @__PURE__ */ e.jsx(f, { iconOnly: !0, ariaLabel: "Back modal", onClick: d, variant: "ghost", children: /* @__PURE__ */ e.jsx(j, { name: "arrow-left", size: "small" }) }) }),
          /* @__PURE__ */ e.jsxs(de, { $alignment: r, $variant: n, children: [
            c && /* @__PURE__ */ e.jsx(Y, { type: "helper", variant: "productive", children: c }),
            /* @__PURE__ */ e.jsx(ce, { children: m })
          ] }),
          /* @__PURE__ */ e.jsx(me, { children: /* @__PURE__ */ e.jsx(f, { iconOnly: !0, ariaLabel: "Close modal", onClick: i, variant: "ghost", children: /* @__PURE__ */ e.jsx(j, { name: "close--large", size: u === "small" ? "small" : "large" }) }) })
        ]
      }
    ) });
  }
);
P.displayName = "ModalHeader";
const A = h(({ children: r, className: t }, o) => /* @__PURE__ */ e.jsx(ue, { className: t, ref: o, children: r }));
A.displayName = "ModalContent";
const D = h(({ children: r, className: t }, o) => /* @__PURE__ */ e.jsx(xe, { className: t, ref: o, children: r }));
D.displayName = "ModalFooter";
const Ae = {
  Content: A,
  Footer: D,
  Header: P,
  RootProvider: k.Provider,
  Wrapper: R
};
export {
  Ae as Modal,
  ge as getDialogAnimations
};
